import type { ParamsValidator } from 'src/components/RouteParamsValidator';
import type { BroadcastRouteParams } from './types';
import { BroadcastUrlTypes } from './types';

export const validateBroadcastType: ParamsValidator<BroadcastRouteParams> = ({ broadcastType }) =>
  Object.values(BroadcastUrlTypes).includes(broadcastType);
